var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInterconnectDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".interconnect-dark_svg__cls-1,.interconnect-dark_svg__cls-3{fill-rule:evenodd;fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Product Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "interconnect-dark_svg__Fill-3",
    className: "interconnect-dark_svg__cls-1",
    d: "M2 13h4v-2H2v2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "interconnect-dark_svg__Fill-6",
    fill: "#fff",
    fillRule: "evenodd",
    d: "M15 17H5V7h10v10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "interconnect-dark_svg__Fill-1",
    className: "interconnect-dark_svg__cls-1",
    d: "M17.33 13H22v-2h-4.67v2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "interconnect-dark_svg__cls-3",
    d: "M8 3v2h9v14H8v2h11V3H8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "interconnect-dark_svg__Fill-7",
    className: "interconnect-dark_svg__cls-3",
    d: "M15 17h-5V7h5v10z"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNHB4IiBoZWlnaHQ9IjI0cHgiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CjxkZWZzPgo8c3R5bGU+LmNscy0xe2ZpbGw6I2ZmZjt9LmNscy0xLC5jbHMtMiwuY2xzLTN7ZmlsbC1ydWxlOmV2ZW5vZGQ7fS5jbHMtMntmaWxsOiNmZmY7fS5jbHMtM3tmaWxsOiNmZmY7fTwvc3R5bGU+CjwvZGVmcz4KPHRpdGxlPkljb25fMjRweF9JbnRlcmNvbm5lY3RfQ29sb3I8L3RpdGxlPgo8ZyBkYXRhLW5hbWU9IlByb2R1Y3QgSWNvbnMiPjxnID48cG9seWdvbiBpZD0iRmlsbC0zIiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iMiAxMyA2IDEzIDYgMTEgMiAxMSAyIDEzIi8+Cjxwb2x5Z29uIGlkPSJGaWxsLTYiIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSIxNSAxNyA1IDE3IDUgNyAxNSA3IDE1IDE3Ii8+Cjxwb2x5Z29uIGlkPSJGaWxsLTEiIGNsYXNzPSJjbHMtMSIgcG9pbnRzPSIxNy4zMyAxMyAyMiAxMyAyMiAxMSAxNy4zMyAxMSAxNy4zMyAxMyIvPgo8cG9seWdvbiBjbGFzcz0iY2xzLTMiIHBvaW50cz0iOCAzIDggNSAxNyA1IDE3IDE5IDggMTkgOCAyMSAxOSAyMSAxOSAxOSAxOSA1IDE5IDMgOCAzIi8+Cjxwb2x5Z29uIGlkPSJGaWxsLTciIGNsYXNzPSJjbHMtMyIgcG9pbnRzPSIxNSAxNyAxMCAxNyAxMCA3IDE1IDcgMTUgMTciLz4KPC9nPgo8L2c+Cjwvc3ZnPg==";
export { SvgInterconnectDark as ReactComponent };